var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_col flex_center"},[_c('div',{staticClass:"baseTagRound",class:_vm.gradeColor},[_vm._v(_vm._s(_vm.grade.slice(0, 1)))]),_c('div',{staticClass:"scoreFont"},[_c('span',{staticClass:"scoreBlack"},[_vm._v(_vm._s(_vm.score)+"점")]),_vm._v(" /200점 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }